import React, {useState, useEffect} from 'react'
import {Modal, Input, Row, Col, Upload, notification } from 'antd'

function ProductModalEdit(props){
    const[nombre, setNombre] = useState(props.nameProduct);
    const[description, setDescription] = useState(props.descProduct);
    const[price, setPrice] = useState(props.priceProduct);
    const[prodId, setProdId] = useState(props.idProduct);
    const[fileList, setFileList] = useState([]);

    useEffect (() => { 
        setNombre(props.nameProduct);
        setDescription(props.descProduct);
        setPrice(props.priceProduct);
        setProdId(props.idProduct); 
    }, [props.idProduct])

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(nombre === "" && props.nameProduct !== "")
            setNombre(props.nameProduct);
        if(description === "" && props.descProduct !== "")
            setDescription(props.descProduct);
        if(price === "" && props.priceProduct !== "")
            setPrice(props.priceProduct);
        if(prodId === "" && props.idProduct !== "")
            setProdId(props.idProduct);

        if(prodId !== ""){
            if(nombre !== ""){
                if(description !== ""){
                    if(price !== "" && price > 0){
                        if(fileList.length > 0){
                            fileList.forEach(file => {
                                const reader = new FileReader();
                                
                                reader.readAsDataURL(file.originFileObj);
                                reader.onload = ({ target }) => { 
                                    const result = target.result; 
                                    const values = { 
                                        name: file.name, 
                                        size: file.size,
                                        base64Data: result.split(",")[1], 
                                        type: result.split(";")[0].split(":")[1] 
                                    };
                
                                    const newProduct = {
                                        image : values.base64Data,
                                        mediaType : values.type,
                                        name : values.name,
                                        prodName: nombre,
                                        prodDesc: description,
                                        prodPrice: price
                                    }
                                    setFileList([]);
                                    props.handleOkModalEdit(newProduct);
                                }; 
                                
                            });
                        }else{
                            const newProduct = {
                                image : null,
                                mediaType : null,
                                name : null,
                                prodName: nombre,
                                prodDesc: description,
                                prodPrice: price
                            }
                            props.handleOkModalEdit(newProduct);
                        }
    
                    }else{
                        msNotification('warning', 'Producto', 'El precio del producto no debe de ser vacio y mayor a 0.');
                    }
                }else{
                    msNotification('warning', 'Producto', 'La descripción del producto no debe de ser vacio.');
                }
            }else{
                msNotification('warning', 'Producto', 'El nombre del producto no debe de ser vacio.');
            }
        }else{
            msNotification('warning', 'Producto', 'El Id del producto no debe de ser vacio.');
        }
        
      };

    const handleCancel = () => {
        setFileList([]);
        props.handleCancelModalEdit();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    const handleIdChange = (e) => {
        setProdId(e.target.value);
    }

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    const handlePriceChange = (e) => {
        const { value } = e.target;
        const reg = /^-?\d*(\.\d*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            setPrice(value);
        }
        
    }

    const propsUpload = {
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
         
        },
        beforeUpload: (newFile ) => {
            console.log(newFile)
            if (newFile.type === 'image/png' || newFile.type === 'image/jpeg') {
                const oldList = [...fileList];
                oldList.push(newFile);
                setFileList(oldList);
                return false;
                
              }else{
                msNotification('warning', 'Categoría', `${newFile.name} el archivo no es .png o .jpg`);
                
              }
              return newFile.type === 'image/png' ? false : newFile.type === 'image/jpeg' ? false : Upload.LIST_IGNORE;
            
        },
        fileList,
        listType: "picture-card",
        onPreview: file => {
            let src = file.url;
            if (!src) {
              src = new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
              });
            }
            const image = new Image();
            image.src = src;
            const imgWindow = window.open(src);
            imgWindow.document.write(image.outerHTML);
        },
        onChange: ({ fileList: newFileList }) => {
            setFileList(newFileList);
        }
      };

    return(
        <React.Fragment>
            <Modal title="Editar Producto" 
            visible={props.modalVisibleEdit} 
            onOk={handleOk} 
            onCancel={handleCancel}>
                <Row>
                    <Col span={24}>
                        <Input key={prodId} defaultValue={prodId} onChange={handleIdChange} placeholder="Id" maxLength="15" disabled/>
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input key={nombre} defaultValue={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input key={description} defaultValue={description} onChange={handleDescriptionChange} placeholder="Descripción" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input key={price} defaultValue={price} onChange={handlePriceChange} placeholder="Precio" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={12}>
                        <Upload {...propsUpload}>
                            {fileList.length < 1 && '+ Upload'}
                        </Upload>
                    </Col>
                    <Col span={12}>
                        <img className="imgWidth" src={props.urlThumbnail}></img>
                    </Col>
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default ProductModalEdit;



// WEBPACK FOOTER //
// ./src/components/ProductModalEdit.jsx